// src/Dashboard/pages/user/Absences/components/AdherentQuickList.jsx

import React from "react";
import { FaSearch } from "react-icons/fa";

import { DEFAULT_USER_PHOTO } from "../constants/absenceConstants";
import {
  formatDate,
  getAbsenceStatus,
  getAdherentName,
  toAbsolutePhotoUrl,
} from "../utils/absenceUtils";

function AdherentSkeletonList() {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="h-16 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800"
        />
      ))}
    </>
  );
}

export default function AdherentQuickList({
  adherents,
  totalAdherents,
  selectedAdherentId,
  onSelect,
  search,
  setSearch,
  loading,
}) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-sm font-bold text-slate-900 dark:text-white">
            Mes adhérents
          </p>

          <p className="text-xs text-slate-500 dark:text-slate-400">
            Sélection rapide
          </p>
        </div>

        <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
          {totalAdherents}
        </span>
      </div>

      <div className="relative mt-3">
        <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

        <input
          type="text"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Rechercher..."
          className="min-h-11 w-full rounded-2xl border border-slate-200 bg-slate-50 py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-violet-300 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
        />
      </div>

      <div className="mt-3 max-h-[360px] space-y-2 overflow-y-auto pr-1">
        {loading ? (
          <AdherentSkeletonList />
        ) : adherents.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-300 p-4 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
            Aucun adhérent trouvé.
          </div>
        ) : (
          adherents.map((adherent) => {
            const active = String(selectedAdherentId) === String(adherent.id);
            const status = getAbsenceStatus(adherent);

            return (
              <button
                key={adherent.id}
                type="button"
                onClick={() => onSelect(adherent.id)}
                className={[
                  "w-full rounded-2xl border p-3 text-left transition",
                  active
                    ? "border-violet-300 bg-violet-50 ring-2 ring-violet-200 dark:border-violet-500/40 dark:bg-violet-500/10 dark:ring-violet-500/20"
                    : "border-slate-200 bg-slate-50 hover:bg-slate-100 dark:border-slate-800 dark:bg-slate-900 dark:hover:bg-slate-800",
                ].join(" ")}
              >
                <div className="flex items-center gap-3">
                  <img
                    src={
                      toAbsolutePhotoUrl(adherent.photo_url) ||
                      DEFAULT_USER_PHOTO
                    }
                    alt={getAdherentName(adherent)}
                    className="h-11 w-11 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                    onError={(event) => {
                      event.currentTarget.src = DEFAULT_USER_PHOTO;
                    }}
                  />

                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-slate-900 dark:text-white">
                      {getAdherentName(adherent)}
                    </p>

                    <p className="mt-0.5 truncate text-xs text-slate-500 dark:text-slate-400">
                      {status.label}
                      {adherent.date_reprise
                        ? ` · ${formatDate(adherent.date_reprise)}`
                        : ""}
                    </p>
                  </div>
                </div>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}